<template>
    <div class="form-page paper">
        <div>
            <el-button
            class="no-print"
            type="warning"
            icon="el-icon-printer"
            size="small"
            @click="printHandler"
            >
                打印
            </el-button>
            <el-button
            type="primary"
            icon="el-icon-download"
            size="small"
            @click="downHandler('tableId')"
            >
                导出
            </el-button>
        </div>
        

        <table cellspacing="0" id="tableId">
            <tr align="center">
                <th :colspan="izscx ? 6 : 4">供应商资格审查表</th>
            </tr>
            <tr>
                <td :colspan="izscx ? 6 : 4">
                    <span>项目名称：{{zbproname}}</span>
					<span>标段名称：{{bdname}}</span>
					<span>评审时间：{{today}}</span>
                </td>
            </tr>
            <tr>
                <td>序号</td>
                <td>供应商</td>
                <td v-if="izscx">审查项</td>
                <td v-if="izscx">审查标准</td>
                <td>审查结果</td>
                <td>签字</td>
            </tr>
            <tbody v-for="(item, index) in tableData" :key="index">
                <tr v-for="(item1, index1) in zgsclist" track-by="$index1">
                    <td v-if="index1 === 0" :rowspan="zgsclist.length">{{index + 1}}</td>
                    <td v-if="index1 === 0" :rowspan="zgsclist.length">{{item.tbdwname}}</td>
                    <td v-if="izscx">{{item1.content}}</td>
                    <td v-if="izscx">{{item1.condition}}</td>
                    <td v-if="index1 === 0" :rowspan="zgsclist.length">
                        {{
                            item.by4 === '1'
                                ? '通过'
                                : (item.by4 === '3' && item.by5)
                        }}
                    </td>
                    <td v-if="index1 === 0" :rowspan="zgsclist.length"></td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import FORM_PAGE_MIXIN from '@views/mixins/form-page'
export default {
    mixins: [ FORM_PAGE_MIXIN ],
    components: { },
    data: () => ({
        tableData: [],
        zgsclist: [],
        zbproname: '',
        bdname: '',
        today: '',
        izscx: '',
    }),
    methods: {
        printHandler() {
            window.print();
        },
        downHandler(tableid){
            if(this.getExplorer()=='ie'){
                var curTbl = document.getElementById(tableid);
                var oXL = new ActiveXObject("Excel.Application");
                //创建AX对象excel
                var oWB = oXL.Workbooks.Add();
                //获取workbook对象
                var oSheet = oWB.ActiveSheet;
                //激活当前sheet
                var sel = document.body.createTextRange();
                sel.moveToElementText(curTbl);
                //把表格中的内容移到TextRange中
                sel.select();
                //全选TextRange中内容
                sel.execCommand("Copy");
                //复制TextRange中内容
                oSheet.Paste();
                //粘贴到活动的EXCEL中
                oXL.Visible = true;
            }else{
                this.tableToExcel(tableid,'','')
            }
            
        },
        tableToExcel(tableid,name,filename) {
            var table = '';
			var uri = 'data:application/vnd.ms-excel;base64,',
					template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html><meta charset="UTF-8">',
					base64 = function(s) {
						return window.btoa(unescape(encodeURIComponent(s)))
					},
					// 下面这段函数作用是：将template中的变量替换为页面内容ctx获取到的值
					format = function(s, c) {
						return s.replace(/{(\w+)}/g,
								function(m, p) {
									return c[p];
								}
						)
					};

			/**/
			//table = document.getElementById(table)
			table = document.getElementById(tableid);
			// 获取表单的名字和表单查询的内容
			var ctx = {worksheet: name || 'Worksheet', table: table.innerHTML};
			// format()函数：通过格式操作使任意类型的数据转换成一个字符串
			// base64()：进行编码
			window.location.href = uri + base64(format(template, ctx))
		},
        getExplorer() {
			var explorer = window.navigator.userAgent ;

			//ie
			if (explorer.indexOf("MSIE") >= 0|| (explorer.indexOf("Windows NT") >= 0 && explorer.indexOf("Trident/7.0;") >= 0)) {
				return 'ie';
			}
			//firefox
			else if (explorer.indexOf("Firefox") >= 0) {
				return 'Firefox';
			}
			//Chrome
			else if(explorer.indexOf("Chrome") >= 0){
				return 'Chrome';
			}
			//Opera
			else if(explorer.indexOf("Opera") >= 0){
				return 'Opera';
			}
			//Safari
			else if(explorer.indexOf("Safari") >= 0){
				return 'Safari';
			}
		}
    },
    created() {
        this.jspInit(`${this.getGetters('bidUrl')}/Zbdl/zgsc/xingtai/print.json`,{
            bdcode:this.getQuery('bdcode')
        }, data => {
            this.tableData = data.kbjllist;
            this.zgsclist = data.zgsclist;
            this.izscx = data.izscx;
            this.jspDataInit(data, ['zbproname', 'bdname', 'today']);
        });
    }
}
</script>

<style scoped lang="scss">
.paper{border:1px solid #DCDFE6; padding:2em; box-sizing:border-box; box-shadow:0 0 5px #DCDFE6;
    table{width:100%; border-left:1px solid #DCDFE6; border-top:1px solid #DCDFE6;
        tr{
            td, th{border-right:1px solid #DCDFE6; border-bottom:1px solid #DCDFE6; padding:.5em;}
        }
    }
    .no-print{margin-bottom:5px;}
}
@media print {
    .paper{width:auto !important; border:none !important; box-shadow:none !important; padding:0 !important;}
}
</style>
